import { Component, Host, Prop, h } from '@stencil/core';
import { SizeVariant } from 'src/types';

@Component({
  tag: 'sportsline-over-under-image',
  styleUrl: 'sportsline-over-under-image.css',
  assetsDirs: ['assets'],
  shadow: true,
})
export class SportslineOverUnderImage {
  /**
   * The size of the logo. Can be 'small', 'medium', 'large', or 'extra-large'.
   */
  @Prop() size: SizeVariant = 'medium';

  /**
   * The image URL for the over/under image.
   */
  @Prop() selection: string = 'over';

  render() {
    return (
      <Host>
        <div
          class={{
            'sportsline-over-under-image': true,
            'sportsline-over-under-image--small': this.size === 'small',
            'sportsline-over-under-image--medium': this.size === 'medium',
            'sportsline-over-under-image--large': this.size === 'large',
            'sportsline-over-under-image--extra-large': this.size === 'extra-large',

            'sportsline-over-under-image--under': this.selection.toLowerCase() === 'under',
            'sportsline-over-under-image--over': this.selection.toLowerCase() === 'over',
          }}
        >
          <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M30 32.5C29.2917 32.5 28.6979 32.2604 28.2188 31.7812C27.7396 31.3021 27.5 30.7083 27.5 30V14.5625L17.75 24.25C17.2917 24.7083 16.7188 24.9479 16.0313 24.9688C15.3438 24.9896 14.75 24.75 14.25 24.25C13.7917 23.7917 13.5625 23.2083 13.5625 22.5C13.5625 21.7917 13.7917 21.2083 14.25 20.75L28.25 6.75C28.5 6.5 28.7708 6.32292 29.0625 6.21875C29.3542 6.11458 29.6667 6.0625 30 6.0625C30.3333 6.0625 30.6458 6.11458 30.9375 6.21875C31.2292 6.32292 31.5 6.5 31.75 6.75L45.75 20.75C46.2083 21.2083 46.4375 21.7812 46.4375 22.4688C46.4375 23.1562 46.2083 23.75 45.75 24.25C45.25 24.75 44.6563 25 43.9688 25C43.2813 25 42.6875 24.75 42.1875 24.25L32.5 14.5625V30C32.5 30.7083 32.2604 31.3021 31.7813 31.7812C31.3021 32.2604 30.7083 32.5 30 32.5ZM30 45C29.2917 45 28.6979 44.7604 28.2188 44.2812C27.7396 43.8021 27.5 43.2083 27.5 42.5V40C27.5 39.2917 27.7396 38.6979 28.2188 38.2188C28.6979 37.7396 29.2917 37.5 30 37.5C30.7083 37.5 31.3021 37.7396 31.7813 38.2188C32.2604 38.6979 32.5 39.2917 32.5 40V42.5C32.5 43.2083 32.2604 43.8021 31.7813 44.2812C31.3021 44.7604 30.7083 45 30 45ZM30 55C29.2917 55 28.6979 54.7604 28.2188 54.2812C27.7396 53.8021 27.5 53.2083 27.5 52.5C27.5 51.7917 27.7396 51.1979 28.2188 50.7188C28.6979 50.2396 29.2917 50 30 50C30.7083 50 31.3021 50.2396 31.7813 50.7188C32.2604 51.1979 32.5 51.7917 32.5 52.5C32.5 53.2083 32.2604 53.8021 31.7813 54.2812C31.3021 54.7604 30.7083 55 30 55Z" />
          </svg>
        </div>
      </Host>
    );
  }
}
